import { useGuid } from '@tv2/velour/libraries/guid';
import { useEffect, useMemo, useRef, useState } from 'react';

export default function WysiwygEditor({
  initialValue,
  onChange,
}: {
  initialValue: string;
  onChange: (value: string) => void;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const id = useGuid('wysiwyg');
  const initial = useRef(initialValue);
  const [loadedWywsiwyg, setLoadedWywsiwyg] = useState(false);
  const [quill, setQuill] = useState<any>();

  useEffect(() => {
    if (id && loadedWywsiwyg === false) {
      setLoadedWywsiwyg(true);
      setQuill(
        new Function(`return new Quill("#${id}", {
          theme: "snow",
          modules: {
            toolbar: [
              [{ header: [3, false] }],
              ['bold', 'italic', 'underline', 'link'],
              [{ list: 'bullet' }],
              ['clean'],
            ],
            clipboard: {
              allowed: {
                tags: ['p', 'h3', 'strong', 'em', 'u', 'a', 'ul', 'li'],
                attributes: ['href'],
              },
            },
          }
        });`)()
      );
    }
  }, [id, loadedWywsiwyg]);

  useEffect(() => {
    if (!quill) return;
    const onChangeFunc = () => {
      onChange(containerRef.current?.children[0]?.innerHTML ?? '');
    };
    quill.on('text-change', onChangeFunc);

    return () => {
      quill.off('text-change', onChangeFunc);
    };
  }, [quill, onChange]);

  return useMemo(
    () => (
      <div
        className="[&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_h3]:mb-2 [&_h3]:text-list-title-2xs"
        id={id}
        ref={containerRef}
        dangerouslySetInnerHTML={{ __html: initial.current }}
      ></div>
    ),
    [id]
  );
}
